import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronLeftSquareOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path d="m8.341 7.998 2.495-2.494.99.99-1.505 1.504 1.505 1.505-.99.99z" fill="currentColor" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M.5 8C.5 1.438 1.438.5 8 .5s7.5.938 7.5 7.5-.937 7.5-7.5 7.5S.5 14.563.5 8m1.4 0c0-1.63.06-2.808.225-3.681.162-.86.4-1.287.654-1.54.253-.253.68-.492 1.54-.654q.434-.082.98-.132v12.014a11 11 0 0 1-.98-.132c-.86-.162-1.287-.4-1.54-.654-.253-.253-.492-.68-.654-1.54C1.96 10.808 1.9 9.63 1.9 8m4.799 6.084Q7.295 14.1 8 14.1c1.63 0 2.808-.06 3.681-.225.86-.162 1.287-.4 1.54-.654.253-.253.492-.68.654-1.54.165-.873.225-2.051.225-3.681s-.06-2.808-.225-3.681c-.162-.86-.4-1.287-.654-1.54-.253-.253-.68-.492-1.54-.654C10.808 1.96 9.63 1.9 8 1.9q-.705 0-1.301.016z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
ChevronLeftSquareOutlinedSize16Glyph.displayName = 'ChevronLeftSquareOutlinedSize16Glyph';
